'use strict';
import UserViewActivityTemplate from './ngTemplates/UserViewActivity.html';
import UserViewChannelsTemplate from './ngTemplates/UserViewChannels.html';
import UserViewHomeTemplate from './ngTemplates/UserViewHome.html';
import {userStates} from './router-config';


routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(userStates.home, {
      title: 'user.views.home.label',
      url: '/home',
      views: {
        'appContent': {
          template: UserViewHomeTemplate,
          controller: 'UserHomeController',
        },
      },
    })

    .state(userStates.chat, {
      title: 'user.views.chat.label',
      url: '/chat',
      views: {
        'appContent': {
          template: UserViewChannelsTemplate,
        },
      },
    })

    .state(userStates.feed, {
      title: 'user.views.activity.title',
      url: '/my-feed',
      views: {
        'appContent': {
          template: UserViewActivityTemplate,
        },
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/user/router.js